/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {
//   // Add custom code below this line

//   // ^^ Keep your scripts inside this IIFE function call to
//   // avoid leaking your variables into the global scope.
// })();



$(document).ready(function() {
 setTimeout(function() {
var url = window.location.href;    
if(url == 'https://unrack.fit/?contact_posted=true'){
    $('html, body').animate({
    scrollTop: $(".scroll_section").offset().top +2000
 });
}
          }, 1000);
   


  
$(".form__item.form__item--submit.jtpl-form-bttn").click(function(){
 $('button.btn.btn').trigger('click');
});

 //  $('.jtpl-video-bttn').click(function(){
 //  $('body').addClass('jtpl-video-popup-overlay');
 // });
$('body').on('click','.jtpl-popup-iverlay',function () {
    $('.jtpl-popup1 .jtpl-popup').hide();
   $('.jtpl-popup1').hide();
});
   
  $('.jtpl-popup1,.jtpl-popup').click(function(){
  $('body').removeClass('jtpl-video-popup-overlay');
 });

    $('body').on('click','.needsclick.kl-private-reset-css-Xuajs1 input',function () {
    // console.log('yes');
    $('.needsclick.kl-private-reset-css-Xuajs1 input').attr('autocomplete','off');
    });
  
  $('body').on('click','.jtpl-klaviyo-bttn',function () {
    var getLenght = $('form.needsclick.klaviyo-form.klaviyo-form-version-cid_1.kl-private-reset-css-Xuajs1').length;
     if(getLenght > 0){
        $('.needsclick.kl-private-reset-css-Xuajs1 input').attr('autocomplete','off');
        $('.custom_kalaviyo-form').show();
         }else{
         $('.custom_kalaviyo-form').hide();
          }
      });
  
      $('body').on('click','.custom_cross_klaviyo',function () {
      $('.custom_kalaviyo-form').hide();
       });

    
//   $(".jtpl-klaviyo-bttn ").click(function(){
//     window._klOnsite = window._klOnsite || [];
// window._klOnsite.push(['openForm', 'VQ6s75']);
// }); 


  
      $('.jtpl-video-bttn').on( 'click', function(){
       $('.jtpl-popup1').show();
        $('.jtpl-popup').show();
       });
        $('a.close').on( 'click', function(){
          $('.jtpl-popup1').hide();
         }); 
  
   //   $('.navtext').click( function(e){
   //       e.preventDefault();
   //      var title = $.trim($(this).attr('data-title'));
   //      $( 'html, body' ).animate({
		 // scrollTop: $('.scroll_section[data-title="'+title+'"]').offset().top -100
   //      }, '300' );
   //       });


      $('body').on('click','.jtpl-scroll-btn',function (e) {
         e.preventDefault();
         var data_title = $.trim($(this).attr('data-title'));
       $( 'html, body' ).animate({
		 scrollTop: $('.scroll_section[data-title="'+data_title+'"]').offset().top -100
        }, '300' );
   });

   
//  //cstm-add-to-quote

// $('.cstm-add-to-quote').click(function () {
//   $('.custom-cart-drawer').show();
//   //  jQuery.ajax({
//   //   type: 'GET',
//   //   url: '/cart',
//   //   data:{
//   //     id: 45203399835812,
//   //     quantity:1,
//   //   },
//   //   dataType: 'json',
//   //   success: function(productid){
//   //     jQuery.ajax({
//   //       type: 'GET',
//   //       url: '/cart',
//   //       dataType: 'json',
//   //       success: function(cart){
//   //           console.log(cart);
//   //             $(".custom-cart-drawer").html($(cart).find(".custom-cart-drawer").html());
//   //         //  $(".cart-count-bubble").html($(cart).find(".cart-count-bubble").html());
//   //       }
//   //     });
//   //   }
//   // });
// })



$('.quote-close-icon').click(function () {
 
   $('.add-to-quote-drawer-container').removeClass('active-quote-drawer');
  $('body').removeClass('quote--drawer-active');
})
 

 $('.cstm-add-to-quote').on('click', function() {
    // formattedProducts.length = 0;
    $('.request-quote-btn').show();
   $('.add-to-quote-drawer-container').addClass('active-quote-drawer');
  $('body').addClass('quote--drawer-active');
var radio_btn = '';
if($('.radio__fieldset').length){
   radio_btn = $('.radio__fieldset input:radio:checked').val();
}
else{
   radio_btn = '';
}

    $('.product-single__variants .select_product_sale_text').each(function () {
      
        var match_title = $(this).attr('option_title');
      if(radio_btn != ''){
    
        if (radio_btn == match_title) {
            var title = $(this).attr('protitle');
            var img = $(this).attr('variant_img');
            var quantity =parseInt($('.select-popout__value').text());
          var id = $(this).attr('value');
          var variant_option = $(this).attr('option_title');
          var variant_price = $(this).attr('variant_price');
          var new_calculated_price = parseInt(variant_price)/100;
            console.log(title);
          console.log(img);
           console.log(id);
          
            var item = {
                id: id,
                title: title,
                img: img,
                quantity: quantity,
                variant_option:variant_option,
                price: $('.product-single__variants .select_product_sale_text').attr('data-price'),
                product_id: $('.product-single__variants .select_product_sale_text').attr('data-id'),
              variant_price:new_calculated_price
            };

            var items = JSON.parse(localStorage.getItem('cartItems')) || [];
            var itemIndex = items.findIndex(i => i.id === item.id);

            if (itemIndex !== -1) {
                items[itemIndex].quantity = parseInt(items[itemIndex].quantity) + parseInt(item.quantity);
            } else {
                items.push(item);
            }
            localStorage.setItem('cartItems', JSON.stringify(items));

            renderCartItems();
        }
      }else{

         var title = $(this).attr('protitle');
            var img = $(this).attr('variant_img');
            var quantity =parseInt($('.select-popout__value').text());
          var id = $(this).attr('value');
          var variant_option = $(this).attr('option_title');
          var variant_price = $(this).attr('variant_price');
          var new_calculated_price = parseInt(variant_price)/100;
            console.log(title);
          console.log(img);
           console.log(id);
          
            var item = {
                id: id,
                title: title,
                img: img,
                quantity: quantity,
                variant_option:'',
                price: $('.product-single__variants .select_product_sale_text').attr('data-price'),
                product_id: $('.product-single__variants .select_product_sale_text').attr('data-id'),
              variant_price:new_calculated_price
            };

            var items = JSON.parse(localStorage.getItem('cartItems')) || [];
            var itemIndex = items.findIndex(i => i.id === item.id);

            if (itemIndex !== -1) {
                items[itemIndex].quantity = parseInt(items[itemIndex].quantity) + parseInt(item.quantity);
            } else {
                items.push(item);
            }
            localStorage.setItem('cartItems', JSON.stringify(items));

            renderCartItems();
      }
    });
 
});


    $('.drawer__overlay').on('click', function(event) {
    
      if ($('.add-to-quote-drawer-container').hasClass('active-quote-drawer')) {
         
        if (!$(event.target).closest('.add-to-quote-drawer').length) {
          $('.add-to-quote-drawer-container').removeClass('active-quote-drawer');
          $('body').removeClass('quote--drawer-active');
        }
      }
    });
 


  

$(document).ready(function () {
    renderCartItems();
});

function renderCartItems() {
    var items = JSON.parse(localStorage.getItem('cartItems')) || [];
    $('.container-for-cart-drawers').empty(); 
    
    items.forEach(function(item) {
        var newDiv = `
            <div class="custom-cart-drawer" custom_id="${item.id}" custom_price="${item.variant_price}">
                <div style="display:flex">
                    <img class="quote-img" src="${item.img}" />
                    <div class="custom-conatiner-sec-div">
                        <div>
                            <p class="quote-title">${item.title}</p>
                            <p class="quote-option">${item.variant_option}</p>
                            <div class="add-product-qty">
                                <div class="custom_quantity_data" data-id="${item.id}" product-price="${item.price}">
                                  <p class="minus_qty custom_main_data decrease_qty" data-attr="minus">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="w-4 h-4 text-white">
                                      <path fill-rule="evenodd" d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z" clip-rule="evenodd"></path>
                                    </svg>
                                  </p> 
                                  <p class="main_value"><strong>${item.quantity}</strong></p> 
                                  <p class="plus_qty custom_main_data increase_qty" data-attr="plus">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="w-4 h-4 text-white">
                                    <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
                                    </svg>
                                  </p> 
                                </div> 
                                <div class="remove_product" product-ids="${item.id}">
                                 <span>remove</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
 `;
        $('.container-for-cart-drawers').append(newDiv);
    });
}


$(document).on('click', '.custom_quantity_data .plus_qty', function () {
  formattedProducts.length = 0;
    var $container = $(this).closest('.custom-cart-drawer');
    var itemId = $container.attr('custom_id');
    var items = JSON.parse(localStorage.getItem('cartItems')) || [];
    var itemIndex = items.findIndex(item => item.id === itemId);

    if (itemIndex !== -1) {
      
        items[itemIndex].quantity = parseInt(items[itemIndex].quantity) + 1;
        localStorage.setItem('cartItems', JSON.stringify(items));
        renderCartItems();
    }
});

$(document).on('click', '.custom_quantity_data .minus_qty', function () {
  formattedProducts.length = 0;
    var $container = $(this).closest('.custom-cart-drawer');
    var itemId = $container.attr('custom_id');
    var items = JSON.parse(localStorage.getItem('cartItems')) || [];
    var itemIndex = items.findIndex(item => item.id === itemId);
if (itemIndex !== -1 && items[itemIndex].quantity > 0) {
       items[itemIndex].quantity -= 1;
 if (items[itemIndex].quantity === 0) {
            items.splice(itemIndex, 1); 
            $container.remove();  }
        localStorage.setItem('cartItems', JSON.stringify(items));
         renderCartItems();
        setTimeout(() => {
            //alert(items[itemIndex] ? items[itemIndex].quantity : 0);
        }, 1000);
    }
});


$(document).on('click', '.remove_product', function () {
  formattedProducts.length = 0;
    var itemId = $(this).parents('.custom-cart-drawer').attr('custom_id');
  
    var items = JSON.parse(localStorage.getItem('cartItems')) || [];

    items = items.filter(item => item.id !== itemId);
    localStorage.setItem('cartItems', JSON.stringify(items));
    $(this).parents('.custom-cart-drawer').remove();
  console.log(formattedProducts.length);
formattedProducts.length = 0;
  localStorage.removeItem('cartItems');
});


// $('.request-quote-btn').click(function () {
// window._klOnsite = window._klOnsite || [];
// window._klOnsite.push(['openForm', 'VUWdgw']);
   
// })

var pro_title = [];
var pro_quant = [];
var pro_option = [];
var pro_price = []; 

function populateTitles() {
    return new Promise((resolve) => {
       
        pro_title = [];
        pro_quant = [];
        pro_option = [];
        pro_price = [];

        $('.custom-cart-drawer').each(function () {
            pro_title.push($(this).find('.quote-title').text());
            pro_quant.push($(this).find('.main_value strong').text());
            pro_option.push($(this).find('.quote-option').text());
        });

        resolve();
    });
}
   var formattedProducts = [];
var productname = [];
function setInputValues() {
   

    
    for (let i = 0; i < pro_title.length; i++) {
        formattedProducts.push(`Title: ${pro_title[i]}, Option: ${pro_option[i]}, Quantity: ${pro_quant[i]}`);
         productname.push(`${pro_title[i]}`);
    }

    const inputData = {
        'Product Info': formattedProducts.join(' | '), 
    };

   
    $('label.needsclick').each(function () {
        const labelText = $(this).text().trim(); 
        const inputField = $(this).next('input');

        if (inputData[labelText] && inputField.length) {
            inputField.val(inputData[labelText]);
            inputField.attr('placeholder', inputData[labelText]);
        }
    });
}
 
function updateInputsPeriodically() {
    populateTitles().then(setInputValues);
}
  $('.request-quote-btn').click(function () {
    formattedProducts.length = 0;
      updateInputsPeriodically();
     console.log(formattedProducts);
  });

$(document).ready(function() {
    updateInputsPeriodically();

    window.addEventListener("klaviyoForms", function(e) {
        console.log(e.detail.type);
        if (e.detail.type === 'open') {
          
            $("button.needsclick.kl-private-reset-css-Xuajs1").attr("type", "submit");
        }
        if (e.detail.type === 'submit' || e.detail.type === 'stepSubmit') {
          setTimeout(function(){
            populateTitles().then(() => {
                var inputData = {
                    'Product Info': formattedProducts.join(' | ') 
                };
                    console.log( inputData['Product Info']);
                _learnq.push(['identify', {
                    'product': inputData['Product Info'],
                    }]);
             $('.custom-cart-drawer').remove();
 $('.request-quote-btn').hide();
           console.log( $('.custom-cart-drawer').length)
                $('.add-to-quote-drawer-container').removeClass('active-quote-drawer');
  $('body').removeClass('quote--drawer-active');
             // formattedProducts.length = 0;
             //  localStorage.removeItem('cartItems');

            });
            },300);
       
        }
    });
});

var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

eventer(messageEvent, function(e) {
    var key = e.message ? "message" : "data";
    var data = e[key];

    // Ensure data is a string before checking for 'event'
    if (typeof data === 'string' && data.includes("event")) {
        var dataParsed = JSON.parse(data);

        if (dataParsed.event == "Tally.FormSubmitted") {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'tally_form_submit'
            });
          $('.custom-cart-drawer').remove();
 $('.request-quote-btn').hide();
           console.log( $('.custom-cart-drawer').length)
                $('.add-to-quote-drawer-container').removeClass('active-quote-drawer');
  $('body').removeClass('quote--drawer-active');
            localStorage.removeItem('cartItems');
        }
    }
});


});
